import { HelmetProvider } from 'react-helmet-async';
import Nav from "./components/NavBar";
import Home from "./pages/Home/index";
import Footer from "./components/Footer";
import "./App.css";




export default function App() {
  return (
    <HelmetProvider>
      <Nav />
      <main>
        <Home />
      </main>
      <Footer />
    </HelmetProvider>
  );
}